import authHeader from "@/services/auth-header";

const API_URL='https://www.dev.ekhonidaktar.com/api';

class CreatePatientService {

    createPatient(form){
        return form.post(`${API_URL}/patients`, {headers: authHeader()});
    }

}

export default new CreatePatientService();